import axiosInstance from 'api/axios';
interface UploadFileParams {
    file?: File;
    language?: string;
    url?: string;
}
export const transcriptGenService = {

    uploadFile: async ({ file, language, url }: UploadFileParams): Promise<any> => {
        const formData = new FormData();
        if (file) {
            formData.append('file', file);
        }
        if (language) {
            formData.append('language', language);
        }
        if (url) {
            formData.append('url', url);
        }

        const response = await axiosInstance.private.post(
            `/api/v1/transcript/upload`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );

        return response.data;
    }

};